/**
 * Hook to run a function on page reload.
 */
import { useEffect } from 'react';

import { useAppContext } from '../context/AppContext';
// import { useRouter } from 'next/router';
import { useLocation } from 'react-router-dom';

export default (functionToRunOnReload: () => void) => {
    // const { asPath } = useRouter();
    const { pathname } = useLocation();
    const { previousURL } = useAppContext();

    useEffect(() => {
        if (previousURL === pathname) {
            functionToRunOnReload();
        }
    }, [pathname]);
};
